const filtroBusquedaSRState = {
  loading: false,
  loadingFile: false,
  solicitudes: [],
  filtros: {
    tipoSolicitud: 0,
    estadoSolicitud: 0,

    idSolicitud: null,
    idSolicitudError: null,

    fechaSolicitudDesde: null,
    fechaSolicitudDesdeError: null,

    fechaSolicitudHasta: null,
    fechaSolicitudHastaError: null,
  },
};

export default filtroBusquedaSRState;
